<app-split class="annex-split-area" [id]="splitComponentId">
  <div class="agreement-annex-container">
    <div class="stepper-container">
      <mat-stepper #stepper orientation="horizontal" linear class="agreement-stepper">
        <!-- Krok 1: Dane podstawowe -->
        <mat-step
          [label]="'Annex.BasicData' | translate"
          [stepControl]="basicStep?.basicDataForm"
          [completed]="isStepCompleted(annexProcessStep.BasicData)"
        >
          <ng-template matStepContent>
            @if (agreement) {
              <div class="step-content">
                <app-basic-data-step
                  [agreement]="agreement"
                  [employmentTypeId]="employmentTypeId"
                  (dataChange)="onBasicDataChange($event)"
                ></app-basic-data-step>
              </div>
            }
          </ng-template>
        </mat-step>

        <!-- Krok 2: Zmieniane dane -->
        <mat-step
          [label]="'Annex.ChangedData' | translate"
          [stepControl]="changedStep?.changedDataForm"
          [completed]="isStepCompleted(annexProcessStep.ChangedData)"
        >
          <ng-template matStepContent>
            <div class="step-content">
              <app-changed-data-step [agreement]="agreement" [dataForAnnex]="dataForAnnex" (dataChange)="onChangedDataChange($event)">
              </app-changed-data-step>
            </div>
          </ng-template>
        </mat-step>

        <!-- Krok 3: Podsumowanie -->
        <mat-step [label]="'Annex.Summary' | translate" [completed]="isStepCompleted(annexProcessStep.Summary)">
          <ng-template matStepContent>
            <div class="step-content">
              <app-summary-step [agreement]="agreement" [dataForAnnex]="dataForAnnex" [annexData]="annexPreviewData"> </app-summary-step>
            </div>
          </ng-template>
        </mat-step>
      </mat-stepper>

      <!-- Przyciski nawigacji -->
      <div class="navigation-buttons">
        <button mat-raised-button type="button" color="accent" (click)="onBackClick()" class="back-button">
          <mat-icon>arrow_back</mat-icon>
          {{ 'Annex.Back' | translate }}
        </button>

        @if (previewError) {
          <button mat-raised-button color="accent" type="button" (click)="retryGeneratePreview()" class="retry-button">
            <mat-icon>autorenew</mat-icon>
            {{ 'Annex.RetryPreview' | translate }}
          </button>
        }
        @if (!isLastStep) {
          <button mat-raised-button color="primary" type="button" [disabled]="!canGoNext" (click)="onNextClick()" class="next-button">
            {{ 'Annex.Next' | translate }}
            <mat-icon>arrow_forward</mat-icon>
          </button>
        }

        @if (isLastStep) {
          <button
            mat-raised-button
            color="accent"
            type="button"
            [disabled]="!canGenerateAnnex || isGenerating"
            (click)="onGenerateAnnexClick()"
            class="generate-button"
          >
            <mat-icon>description</mat-icon>
            {{ 'Annex.SendToApproval' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</app-split>
